import { Component, OnInit, OnDestroy, NgZone, EventEmitter, ViewChild, Output } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import {
	Device,
    DeviceService
} from './../../../shared/index';

@Component({
    selector: 'device-filter',
    templateUrl: './device-filter.html',
    standalone: false
})

export class DeviceFilterComponent implements OnInit, OnDestroy {
	@ViewChild('deviceFilter') deviceFilter: ModalDirective;
	@Output() isProcessing = new EventEmitter<boolean>();

	private subscriptions: Subscription[] = [];

	public devices: Device[] = [];

	public filterApplied = false;
	public allEmployees = true;
	public name = '';
	public ableToPrint = true;
	public notAbleToPrint = true;

	constructor(
		private _ngZone: NgZone,
		private _deviceService: DeviceService
	)
	{
	}

	updateProcessing(value: boolean) {
		this.isProcessing.emit(value);
	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
	}

	public showFilters(): void {
		this.deviceFilter.show();
	}

	public applyFilter(): void {

		this.updateProcessing(true);
		this._deviceService.name = this.name;
		if (this.name != '') {
			this.filterApplied = true;
			this._deviceService.applyFilter(this.name);
		} else {
			this.filterApplied = false;
			this._deviceService.getDevices();
		}
		this.deviceFilter.hide();
	}

	public clearFilter(): void {
		this.name = '';
		this.allEmployees = true;
		this.filterApplied = false;
		this.ableToPrint = true;
		this.notAbleToPrint = true;
	}

}
